enum ActivityDirection {
    Outbound = 1,
    Inbound = 2
}

export default ActivityDirection;

export const ActivityDirectionLabels: { [key: number]: string } = {
    [ActivityDirection.Outbound]: 'Outbound',
    [ActivityDirection.Inbound]: 'Inbound'
};

export const ActivityDirectionIcons: { [key: number]: string } = {
    [ActivityDirection.Outbound]: 'mdi-arrow-top-right',
    [ActivityDirection.Inbound]: 'mdi-arrow-bottom-left'
};
